import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["submitButton"];

  idpChanged(event) {
    this.submitButtonTarget.classList.remove("hidden");
  }
}
